export default function DOM_NodeTypes() {
  return (
    <div>
      <h1>DOM_NodeTypes</h1>
      <p>This is the DOM_NodeTypes component.</p>
    </div>
  );
}